<div class="h-100 box d-flex flex-column" elementDataTest="videoStatusInfoElement">
    <div class="text-grey-v6">
        <span
            class="d-block icon upload-icon-video"
            [inlineSVG]="contentType === 'video' ? 'assets/icons.svg#content-video' : 'assets/icons.svg#content-document'"
        ></span>
        <p
            class="font-semi-bold text-l text-center text-break"
            [innerHTML]="
                contentType === 'video'
                    ? ('v3-byoc-popup-create-episode-video-status-info-text-1' | translate: { videoName: contentName })
                    : ('v3-byoc-popup-create-episode-document-status-info-text-1' | translate: { documentName: contentName })
            "
        ></p>
        <p class="font-semi-bold text-l text-center text-break">
            {{
                contentType === 'video'
                    ? ('v3-byoc-popup-create-episode-video-status-info-text-2' | translate)
                    : ('v3-byoc-popup-create-episode-document-status-info-text-2' | translate)
            }}
        </p>
    </div>
    <div class="theme-new d-flex align-items-center justify-content-center">
        <button
            class="btn btn-secondary btn-go-to-list px-2 text-wrap"
            translate
            buttonDataTest="goToManageCustomContent"
            [routerLink]="['/manager', 'settings', 'content', 'byoc', 'list']"
        >
            <span class="text-s font-bold">{{ 'v3-byoc-popup-create-episode-video-status-info-btn' | translate }}</span>
            <span class="icon icon-s btn-arrow" inlineSVG="assets/icons-color.svg#btn-arrow-right"></span>
        </button>
    </div>
</div>
